/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: acbca1ab341e
 */

import * as z from "zod";

/**
 * The folder move/rename request.
 */
export type MoveFolderRequest = { to_folder: string };

export const MoveFolderRequest$zodSchema: z.ZodType<MoveFolderRequest> = z
  .object({
    to_folder: z.string().describe("The new path for the folder."),
  }).describe("The folder move/rename request.");
